import type { ReactNode } from 'react';

type Props = {
  readonly crumbs: readonly string[];
  readonly action?: ReactNode;
};

export function Topbar({ crumbs, action }: Props) {
  return (
    <header className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <span key={`${i}-${c}`} className={isLast ? 'cur' : ''}>
              {c}
              {!isLast && <span className="sep" style={{ marginLeft: '0.625rem' }}>/</span>}
            </span>
          );
        })}
      </div>
      {action && <div className="top-actions">{action}</div>}
    </header>
  );
}
